/*
  Aparición sutil al hacer scroll (rediseño).
  - Solo secciones que están DEBAJO del pliegue al cargar: lo que se ve de entrada
    nunca se oculta ni se anima (no afecta LCP ni CLS).
  - Nada se oculta sin JS: la clase .tt-reveal la pone este script.
  - Respeta "reducir movimiento" del sistema.
  - Escalonado de 40 ms entre tarjetas de una grilla (máx. 8 pasos).
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ITEMS = '.tcg-item, .cc-item, .tb-card, .ts-card, .fc-card, .col-scroll-cell, .productgrid--item, .highlights-banner__block, .tt-reel';
  var MAX_STEPS = 8, STEP_MS = 40;

  function init() {
    var sections = document.querySelectorAll('.site-main > .shopify-section');
    var fold = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var s = e.target;
        io.unobserve(s);
        // Escalonado: solo las tarjetas visibles en la fila (las demás, sin demora)
        var i = 0;
        s.querySelectorAll(ITEMS).forEach(function (it) {
          var r = it.getBoundingClientRect();
          if (r.left < window.innerWidth && r.right > 0 && i < MAX_STEPS) {
            it.style.setProperty('--tt-reveal-delay', (i * STEP_MS) + 'ms');
            it.classList.add('tt-reveal-item');
            i++;
          }
        });
        requestAnimationFrame(function () { s.classList.add('is-revealed'); });
        // Limpieza: quita las clases al terminar para no interferir con hovers/carruseles
        setTimeout(function () {
          s.classList.remove('tt-reveal', 'is-revealed');
          s.querySelectorAll('.tt-reveal-item').forEach(function (it) { it.classList.remove('tt-reveal-item'); it.style.removeProperty('--tt-reveal-delay'); });
        }, 1200);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    sections.forEach(function (s) {
      var top = s.getBoundingClientRect().top;
      if (top < fold || s.offsetHeight === 0) return;   // visible al cargar: no se toca
      s.classList.add('tt-reveal');
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
